module.exports = __webpack_public_path__ + "static/media/17a-03_ST-2017-280x350cm-oleo-sobre-madera.c0e895c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17a/17a-03_ST-2017-280x350cm-oleo-sobre-madera.jpg
// module id = 206
// module chunks = 0